import { useNavigate } from "react-router-dom";

import logoIcon from "@/shared/assets/logo/logo-icon.svg";
import { LAWYER_ROUTES } from "@/shared/constants/paths";
import { Button } from "@/shared/components/ui/button";

export const DemoBanner = () => {
  const navigate = useNavigate();

  return (
    <div className="flex-shrink-0 bg-[#003922] px-4 py-3 flex flex-wrap items-center justify-between gap-2 sm:py-4">
      <div className="flex items-center gap-2">
        <img src={logoIcon} alt="" aria-hidden="true" className="size-6 shrink-0" />
        <span className="text-sm font-medium text-white">Elayne for Attorneys</span>
      </div>
      <Button variant="outline" size="sm" onClick={() => navigate(LAWYER_ROUTES.SIGNUP)}>
        Create account
      </Button>
    </div>
  );
};
